var _rect, _rect2, _path, _path2, _path3, _use, _use2, _use3, _use4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSingapore = function SvgSingapore(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 4320 2880",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#ed2939",
    width: 4320,
    height: 1440
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    y: 1440,
    width: 4320,
    height: 1440
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M 1481.678,720 A 541.5,541.5 0 1 1 398.67798,720 A 541.5,541.5 0 1 1 1481.678,720 z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ed2939",
    d: "M 1651.835,720 A 511.73499,511.73499 0 1 1 628.36499,720 A 511.73499,511.73499 0 1 1 1651.835,720 z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    id: "star",
    d: "M 1007.1951,733.06439 L 933.63466,676.63425 L 860.09279,733.09117 L 888.40587,642.09687 L 814.61147,586.0053 L 905.6704,586.1981 L 933.6049,495.07467 L 961.56934,586.18798 L 1052.6282,585.96246 L 978.8522,642.0808 L 1007.1951,733.06439 z"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    transform: "translate(577.18853,0)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    transform: "translate(288.88853,-214.21117)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    transform: "translate(107.99953,342.74883)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    transform: "translate(469.18853,342.74883)"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSingapore);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSIwIDAgNDMyMCAyODgwIj4KPHJlY3QgZmlsbD0iI2VkMjkzOSIgd2lkdGg9IjQzMjAiIGhlaWdodD0iMTQ0MCIvPgo8cmVjdCBmaWxsPSIjZmZmIiB5PSIxNDQwIiB3aWR0aD0iNDMyMCIgaGVpZ2h0PSIxNDQwIi8+CjxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0gMTQ4MS42NzgsNzIwIEEgNTQxLjUsNTQxLjUgMCAxIDEgMzk4LjY3Nzk4LDcyMCBBIDU0MS41LDU0MS41IDAgMSAxIDE0ODEuNjc4LDcyMCB6Ii8+CjxwYXRoIGZpbGw9IiNlZDI5MzkiIGQ9Ik0gMTY1MS44MzUsNzIwIEEgNTExLjczNDk5LDUxMS43MzQ5OSAwIDEgMSA2MjguMzY0OTksNzIwIEEgNTExLjczNDk5LDUxMS43MzQ5OSAwIDEgMSAxNjUxLjgzNSw3MjAgeiIvPgo8cGF0aCBmaWxsPSIjZmZmIiBpZD0ic3RhciIgZD0iTSAxMDA3LjE5NTEsNzMzLjA2NDM5IEwgOTMzLjYzNDY2LDY3Ni42MzQyNSBMIDg2MC4wOTI3OSw3MzMuMDkxMTcgTCA4ODguNDA1ODcsNjQyLjA5Njg3IEwgODE0LjYxMTQ3LDU4Ni4wMDUzIEwgOTA1LjY3MDQsNTg2LjE5ODEgTCA5MzMuNjA0OSw0OTUuMDc0NjcgTCA5NjEuNTY5MzQsNTg2LjE4Nzk4IEwgMTA1Mi42MjgyLDU4NS45NjI0NiBMIDk3OC44NTIyLDY0Mi4wODA4IEwgMTAwNy4xOTUxLDczMy4wNjQzOSB6Ii8+Cjx1c2UgeGxpbms6aHJlZj0iI3N0YXIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDU3Ny4xODg1MywwKSIvPgo8dXNlIHhsaW5rOmhyZWY9IiNzdGFyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyODguODg4NTMsLTIxNC4yMTExNykiLz4KPHVzZSB4bGluazpocmVmPSIjc3RhciIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTA3Ljk5OTUzLDM0Mi43NDg4MykiLz4KPHVzZSB4bGluazpocmVmPSIjc3RhciIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDY5LjE4ODUzLDM0Mi43NDg4MykiLz4KPC9zdmc+Cg==";